import React from 'react';
import PropTypes from 'prop-types';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box } from '@material-ui/core';
import { TextField, Typography } from '@orijinworks/frontend-commons';
import SectionTitle from '../SectionTitle';
import {
  templateNameFieldSx,
  useTemplateNameSectionStyles,
} from './TemplateNameSection.styles';

/**
 * Template name input section shown when creating a reusable template.
 * Matches Figma Template Name (967:31123 / 967:31124).
 */
export const TemplateNameSection = ({ templateName, onTemplateNameChange }) => {
  const classes = useTemplateNameSectionStyles();

  return (
    <Box className={classes.root}>
      <SectionTitle title="Template Name" />
      <Box className={classes.fieldWrap}>
        <TextField
          label="Template Name"
          placeholder="e.g. Reentry Plan"
          variant="outlined"
          fullWidth
          value={templateName}
          onChange={(event) => onTemplateNameChange(event.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={templateNameFieldSx}
        />
        <Box className={classes.supportingText}>
          <InfoOutlinedIcon className={classes.infoIcon} fontSize="inherit" />
          <Typography variant="subtitle1" className={classes.helper}>
            Description can be added in the template editor
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

TemplateNameSection.propTypes = {
  templateName: PropTypes.string,
  onTemplateNameChange: PropTypes.func.isRequired,
};

TemplateNameSection.defaultProps = {
  templateName: '',
};

export default TemplateNameSection;
